// Fertig unterschriebenes Dokument per E-Mail verschicken (Signieren-Bereich).
//
// Reine Bausteine für die Verfassen-Pille: Dateiname, Empfänger, Betreff, Text. Die
// Unterzeichner haben beim Abschluss bereits automatisch eine Kopie bekommen — dieser Weg
// ist für alle anderen (Eigentümer, Hausverwaltung, Handwerker) gedacht, deshalb sind die
// Unterzeichner nur ein Vorschlag und keine feste Empfängerliste.

export interface VersandVorgang {
  titel: string;
  signiert_path?: string | null;
  unterzeichner?: { name?: string | null; email?: string | null }[] | null;
  bezug?: Record<string, string | null> | null;
}

/** Dateiname des Anhangs: Titel als Datei-Name, immer mit .pdf. */
export function signaturDateiname(v: VersandVorgang): string {
  const roh = (v.titel || 'Dokument').trim() || 'Dokument';
  const sauber = roh.replace(/[\\/:*?"<>|]+/g, '-').replace(/\s+/g, ' ').trim();
  return sauber.toLowerCase().endsWith('.pdf') ? sauber : `${sauber}.pdf`;
}

/** Betreff: Titel des Vorgangs, damit die Mail im Postfach wiederzufinden ist. */
export function versandBetreff(v: VersandVorgang): string {
  return (v.titel || 'Unterschriebenes Dokument').trim() || 'Unterschriebenes Dokument';
}

/** Vorschlag für „An": die Unterzeichner mit E-Mail (entdoppelt, Reihenfolge bleibt). */
export function versandEmpfaenger(v: VersandVorgang): string[] {
  const gesehen = new Set<string>();
  const raus: string[] = [];
  for (const u of v.unterzeichner || []) {
    const mail = (u?.email || '').trim();
    if (!mail || !mail.includes('@')) continue;
    const key = mail.toLowerCase();
    if (gesehen.has(key)) continue;
    gesehen.add(key);
    raus.push(mail);
  }
  return raus;
}

/** Kurzer Begleittext — der Nutzer schreibt darunter weiter. */
export function versandText(v: VersandVorgang): string {
  const namen = (v.unterzeichner || [])
    .map((u) => (u?.name || '').trim())
    .filter(Boolean);
  const zeilen = [
    'Guten Tag,',
    '',
    `anbei erhalten Sie das unterschriebene Dokument „${(v.titel || 'Dokument').trim()}".`,
  ];
  if (namen.length) zeilen.push('', `Unterzeichnet von: ${namen.join(', ')}.`);
  zeilen.push('', 'Mit freundlichen Grüßen');
  return zeilen.join('\n');
}
